module.exports = __webpack_public_path__ + "img/c1.dd6c42f6.png";